import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { ResponseEmployeeNotif, RequestEmployeeNotif } from "../dto/face-thermal-user.dto";

@Injectable()
export class FaceThermalUserApi {

    private service: string = 'attendanceFaceUserLists';
    private model: string = 'attendanceFaceUserLists';

    constructor(
        private nestApiProvider: NestApiProvider
    ) {

    }

    public getEmployeeNotif(page: number, search: string = ''): Observable<ResponsePaging<ResponseEmployeeNotif>> {
        const method: string = 'GET';
        const func: string = '';
        const params: any = {};
        const urlParams: any = {
            page: page,
            search: search,
        };
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponsePaging<ResponseEmployeeNotif>>(method, url, params, urlParams, body);
    }

    public getEmployeeNotifByEmail(search: any): Observable<ResponseData<ResponseEmployeeNotif>> {
        const method: string = 'GET';
        const func: string = '';
        const params: any = {};
        const urlParams: any = {
            search: search
        };
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<ResponseEmployeeNotif>>(method, url, params, urlParams, body);
    }

    public setEmployeeNotif(data: RequestEmployeeNotif): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = '';
        const params: any = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public editEmployeeNotif(data: RequestEmployeeNotif): Observable<ResponseData<any>> {
        const method: string = 'PUT';
        const func: string = '';
        const params: any = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public deleteEmployeeNotif(email: string): Observable<ResponseData<any>> {
        const method: string = 'DELETE';
        const func: string = '';
        const params: any = {};
        const urlParams: any = {
            email: email
        };
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public highTemperatures(payload: { page: number, limit: number }): Observable<ResponsePaging<any>> {
        const method: string = 'GET';
        const func: string = 'highTemperatures';
        const params: any = {};
        const urlParams: any = payload;
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponsePaging<any>>(method, url, params, urlParams, body);
    }



}





// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/face-thermal-user.api.ts